// extracted by mini-css-extract-plugin
export var core = "HeroAnimation-module--core--3fe3b";
export var dash = "HeroAnimation-module--dash--00f35";
export var dashedLine = "HeroAnimation-module--dashed-line--bc210";